import { render, staticRenderFns } from "./TheArticoli.vue?vue&type=template&id=5c5eb7f7&scoped=true&"
import script from "./TheArticoli.vue?vue&type=script&lang=ts&"
export * from "./TheArticoli.vue?vue&type=script&lang=ts&"
import style0 from "./TheArticoli.vue?vue&type=style&index=0&id=5c5eb7f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5eb7f7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSkeletonsTheCorsi: require('/usr/src/nuxt-app/components/elements/skeletons/TheCorsi.vue').default,ElementsTheError: require('/usr/src/nuxt-app/components/elements/TheError.vue').default})
